import { useState } from 'react';
import t from 'react-translate';
import { config } from '@config/pendo.config.json';
import NvIcon from 'shared/components/nv-icon';
import NvTooltip from 'shared/components/nv-tooltip';
import ClickableContainer from 'components/clickable-container';
import { gray6 } from 'styles/global_defaults/colors';

type EditIconViewModeProps = {
  id: number;
  onClick: (e: React.MouseEvent<HTMLDivElement>) => void;
};

const EditIconViewMode = ({ id, onClick }: EditIconViewModeProps) => {
  const [showEditTooltip, setShowEditTooltip] = useState(false);
  return (
    <div className='d-flex session-edit align-items-center justify-content-center'>
      <NvTooltip
        text={t.MENTORING_PROGRAMS.PARTICIPANT_HOME.PLAN_SESSION_FLYOUT.EDIT_SESSION_TOOLTIP()}
        placement='top'
        show={showEditTooltip}
        preventOverflow={false}
        zIndex={5092}
      >
        <ClickableContainer
          onClick={onClick}
          onMouseOver={() => setShowEditTooltip(true)}
          onMouseOut={() => setShowEditTooltip(false)}
          data-qa={config.pendo.athena.mentorshipProgram.sessionInfo}
          data-qa-id={`${config.pendo.athena.mentorshipProgram.sessionInfo}_${id ?? '1'}`}
          aria-label={t.MENTORING_PROGRAMS.PARTICIPANT_HOME.PLAN_SESSION_FLYOUT.EDIT_SESSION_TOOLTIP()}
        >
          <NvIcon
            icon='edit'
            size='small'
            color={gray6}
            className='p-2'
            onMouseOver={() => setShowEditTooltip(true)}
            onMouseOut={() => setShowEditTooltip(false)}
          />
        </ClickableContainer>
      </NvTooltip>
    </div>
  );
};

export default EditIconViewMode;
